import { toKebabCase } from '../strings'

type GenerateQualityAssuranceId = (action: string) => string

export const useQualityAssuranceNamespace =
  (namespace: string): GenerateQualityAssuranceId =>
  (action: string) =>
    `${namespace}.${toKebabCase(action)}`
